module.exports = __webpack_public_path__ + "static/media/copy-file.4177c43b.svg";